import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { SiteLayout } from "../components/site/SiteLayout";
import { useSeo } from "../lib/seo";
import {
  productAgriBrain360,
  productCertisfy,
  productWaldInsights,
  productWaldFlow,
} from "../lib/content";
import { CTABlock } from "./ServicesPage";

const productCards = [
  { product: productAgriBrain360, path: "/products/agribrain-360", testId: "agribrain360" },
  { product: productCertisfy, path: "/products/certisfy", testId: "certisfy" },
  { product: productWaldInsights, path: "/products/waldinsights", testId: "waldinsights" },
  { product: productWaldFlow, path: "/products/waldflow", testId: "waldflow" },
];

export default function ProductsPage() {
  useSeo({
    title: "Wald Products — AgriBrain 360, Certisfy, WaldInsights, WaldFlow",
    description:
      "Wald's product portfolio: AgriBrain 360 (farm data & analytics), Certisfy (compliance & document workflow), WaldInsights and WaldFlow.",
    path: "/products",
  });
  return (
    <SiteLayout>
      <section className="border-b border-border">
        <div className="container-wald py-20 md:py-28">
          <div className="eyebrow mb-6">Products</div>
          <h1 className="font-display text-4xl md:text-6xl leading-[1.02] tracking-tight max-w-4xl">
            Our products.
          </h1>
          <p className="mt-6 max-w-2xl opacity-80 leading-relaxed text-lg">
            Software Wald builds and maintains, described here at each product's current stage.
          </p>
        </div>
      </section>
      {productCards.map((card, i) => (
        <section key={card.testId} className={`border-b border-border ${i % 2 === 1 ? "bg-card" : ""}`}>
          <div className="container-wald py-16">
            <div className="max-w-2xl">
              <h2 className="font-display text-3xl md:text-5xl tracking-tight mb-4 leading-[1.05]">
                {card.product.title}
              </h2>
              <p className="opacity-90 leading-relaxed text-lg mb-6">{card.product.tagline}</p>
              <Link to={card.path} data-testid={`products-${card.testId}-link`} className="btn-copper">
                Explore {card.product.title} <ArrowRight size={14} strokeWidth={2} />
              </Link>
            </div>
          </div>
        </section>
      ))}
      <CTABlock />
    </SiteLayout>
  );
}
